import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 0, label: 'Unspecified' },
    { value: 1, label: 'Report' },
    { value: 2, label: 'Plan' },
  ],
});
